var React = require('react');

function ArrowMore (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m1.6.9 42 42L1.2 85.2","stroke":"currentColor","strokeWidth":"2"}));
}

ArrowMore.defaultProps = {"fill":"none","viewBox":"0 0 46 86"};

module.exports = ArrowMore;

ArrowMore.default = ArrowMore;
